/**
 * Created by Marthijn on 01-08-17.
 */
import React from 'react';
import Parse from 'parse';
import ActionList from "./actionlist";

const COMPLETED = "completed";

export default class MyActions extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            actions: [],
        };
    }

    componentDidMount() {

        // let _this = this;

        let projectsQuery = new Parse.Query("Project");
        projectsQuery.notEqualTo("deleted", true);

        let query = new Parse.Query("Action");
        query.ascending("deadline");
        query.equalTo("user", Parse.User.current());
        query.notEqualTo("status", COMPLETED);
        query.include("user");
        query.include("user.info");
        query.notEqualTo("deleted", true);
        query.matchesQuery("project", projectsQuery);
        query.find().then(actions => {

            this.setState({
                actions: actions,
            })
        })

    }

    render() {
        return (
            <div>
                <div className="negative-margin">
                    <h2>My actions</h2>
                    <ActionList actions={this.state.actions} showProject={true}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/myactions.js